import { ProgressMeetingReportDto } from '@cradua/data';
import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import * as ProgressMeetingActions from './progress-meeting.actions';

export const PROGRESS_MEETING_FEATURE_KEY = 'progressMeeting';

export interface ProgressMeetingState
  extends EntityState<ProgressMeetingReportDto> {
  selectedProgressMeetingId?: string | number; // which ProgressMeeting record has been selected
  loaded: boolean; // has the ProgressMeeting list been loaded
  error?: string | null; // last none error (if any)
}

export interface ProgressMeetingPartialState {
  readonly [PROGRESS_MEETING_FEATURE_KEY]: ProgressMeetingState;
}

export const progressMeetingAdapter: EntityAdapter<ProgressMeetingReportDto> = createEntityAdapter<
  ProgressMeetingReportDto
>({
  selectId: (progressMeeting) => progressMeeting.id,
  sortComparer: false,
});

export const initialState: ProgressMeetingState = progressMeetingAdapter.getInitialState(
  {
    // set initial required properties
    loaded: false,
    error: null,
    selectedProgressMeetingId: null,
  }
);

const progressMeetingReducer = createReducer(
  initialState,
  on(ProgressMeetingActions.loadProgressMeeting, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(
    ProgressMeetingActions.loadProgressMeetingSuccess,
    (state, { progressMeeting }) =>
      progressMeetingAdapter.addAll(progressMeeting, {
        ...state,
        loaded: false,
      })
  ),
  on(ProgressMeetingActions.loadProgressMeetingFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  on(ProgressMeetingActions.addProgressMeeting, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(
    ProgressMeetingActions.addProgressMeetingSuccess,
    (state, { newProgressMeeting }) =>
      progressMeetingAdapter.addMany(newProgressMeeting, {
        ...state,
        loaded: false,
      })
  ),
  on(ProgressMeetingActions.addProgressMeetingFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),

  on(ProgressMeetingActions.updateProgressMeeting, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(
    ProgressMeetingActions.updateProgressMeetingSuccess,
    (state, { updateProgressMeeting }) =>
      progressMeetingAdapter.upsertMany(updateProgressMeeting, {
        ...state,
        loaded: false,
      })
  ),
  on(
    ProgressMeetingActions.updateProgressMeetingFailure,
    (state, { error }) => ({
      ...state,
      loaded: false,
      error,
    })
  ),
  // search student

  on(ProgressMeetingActions.searchProgressMeetingRecord, (state, { query }) => {
    return {
      ...state,
      selectedProgressMeetingId: query,
      loaded: false,
      error: null,
    };
  }),
  on(ProgressMeetingActions.removeProgressMeeting, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(ProgressMeetingActions.removeProgressMeetingSuccess, (state, { ids }) =>
    progressMeetingAdapter.removeMany(ids, { ...state, loaded: false })
  ),
  on(
    ProgressMeetingActions.removeProgressMeetingFailure,
    (state, { error }) => ({
      ...state,
      loaded: false,
      error,
    })
  )
);

export function reducer(
  state: ProgressMeetingState | undefined,
  action: Action
) {
  return progressMeetingReducer(state, action);
}
